import React, { Component } from "react";
import Head from "next/head";
import { connect } from "react-redux";
import withRouterPageLayout from "@components/withRouterPageLayout.js";
import getConfig from "next/config";

import { getRegionsWithStores } from "@lib/helpers";
import { getRegions } from "@store/user/actions";
import { getStores } from "@store/stores/actions";
import { getSupportCategories } from "@store/support/actions";

import Breadcrumbs from "@components/Breadcrumbs";
import SupportLayout from "@containers/Support/Layout";
import StoresLayout from "@components/Stores/StoresLayout";
import StoresContainer from "@containers/Stores";
import ErrorPage from "@containers/ErrorPage";

const {
  publicRuntimeConfig: { settings },
} = getConfig();

class StoresPage extends Component {
  render() {
    const { stores, regions, supportCategories } = this.props;

    // Check store data
    if (!stores || !regions) {
      return <ErrorPage>{`Nu au fost gasite magazine`}</ErrorPage>;
    }

    // Get stores in the network
    const storesList = stores.filter(
      (store) => store.network === settings.websiteId
    );

    const regionsList = getRegionsWithStores({ regions, stores: storesList });

    return (
      <>
        <Head>
          <title>{`Lant de magazine`}</title>
        </Head>

        <Breadcrumbs
          className="pt-3"
          breadcrumbs={[
            {
              id: 1,
              level: 2,
              name: `Suport clienti`,
              url_key: "suport-clienti/",
            },
            {
              id: 2,
              level: 99,
              name: `Magazine`,
            },
          ]}
        />

        <SupportLayout categories={supportCategories}>
          <StoresLayout title={`Magazine`} regions={regionsList}>
            <StoresContainer stores={storesList} regions={regionsList} />
          </StoresLayout>
        </SupportLayout>
      </>
    );
  }
}

StoresPage.getInitialProps = async (ctx) => {
  const { reduxStore, query } = ctx;

  // Get data from store
  const { categories } = reduxStore.getState().support;
  const { regions } = reduxStore.getState().user;
  const { stores } = reduxStore.getState();
  const promises = [];

  // Load data
  !categories && promises.push(reduxStore.dispatch(getSupportCategories()));
  !regions && promises.push(reduxStore.dispatch(getRegions()));
  !stores.data && promises.push(reduxStore.dispatch(getStores()));

  await Promise.all(promises);
  return { query };
};

StoresPage.pageLayout = "default";
StoresPage.layoutProps = {
  displaySearch: false,
};

export default withRouterPageLayout(
  connect((state) => ({
    stores: state.stores.data,
    regions: state.user.regions,
    supportCategories: state.support.categories,
  }))(StoresPage)
);
